export const culture = {
    locale: "pl-PL",
    monthNames: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
    monthNamesShort: ['Sty', 'Lu', 'Mar', 'Kw', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Pa', 'Lis', 'Gru'],
    dayNames: ['Niedziela', 'Poniedzialek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    dayNamesShort: ['Nie', 'Pn', 'Wt', 'Śr', 'Czw', 'Pt', 'So'],
    dayNamesMin: ['N', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So'],
    weekHeader: 'Tydz',
    dateFormat: 'yy-mm-dd',
    datePlaceholder: 'yyyy-mm-dd',
    firstDay: 1,
    monthDayFormat: 'mm-dd',
    shortFormat: "d M",
    mediumFormat: "d M, y",
    mediumFullYearFormat: "d M, yy",
    monthShortFormat: "M yy",
    yearFormat: "yy",
    FullFormat: "dd M, yy",
    LongTimeFormat: 'HH:mm:ss',
    shortTimeFormat: 'HH:mm',
    decimalSeparator: ",",
    currencyDecimalSeparator: ',',
    currencyGroupSeparator: ' ',
    moneyWithCurrencyFormat: "{v} {c}",
    from: 'Od',
    by: 'Przez',
    fromFormat: 'Od {0}',
    byFormat: 'Przez {0}'
};

export const datepicker = {
    ...culture,
    closeText: 'Zamknij',
    prevText: '&#x3c;Poprzedni',
    nextText: 'Następny&#x3e;',
    currentText: 'Dziś',
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: ''
};
